import React, { useState } from 'react';

const SALES_DATA = [
  { region: 'North', q1: 18420000, q2: 21870000, q3: 24100000, q4: 31560000 },
  { region: 'South', q1: 14200000, q2: 16500000, q3: 19800000, q4: 22400000 },
  { region: 'East',  q1: 22100000, q2: 24300000, q3: 27500000, q4: 29800000 },
  { region: 'West',  q1: 9800000,  q2: 11200000, q3: 13600000, q4: 15900000 },
  { region: 'Central', q1: 16700000, q2: 18900000, q3: 21200000, q4: 28700000 },
];

// Q4 averages (monthly = Q4/3):
// North: 31560000/3 = 10520000
// South: 22400000/3 = 7466667
// East:  29800000/3 = 9933333  <- this is close but North wins
// West:  15900000/3 = 5300000
// Central: 28700000/3 = 9566667
// Highest Q4 avg = North

// Top = North(31560000), Bottom = West(15900000)
// Difference = 31560000 - 15900000 = 15660000

// North Q3→Q4 growth = 31560000 - 24100000 = 7460000 increase
// Q1 2026 projected = 31560000 + 7460000 = 39020000

const EXPECTED = {
  topRegion: 'North',
  difference: '₹1,56,60,000',
  projected: '₹3,90,20,000',
};

const fmt = (n) => '₹' + n.toLocaleString('en-IN');

export default function C15_DataReasoning({ onComplete }) {
  const [answers, setAnswers] = useState({ topRegion: '', difference: '', projected: '' });
  const [submitted, setSubmitted] = useState(false);

  const ch = (e) => setAnswers(a => ({ ...a, [e.target.name]: e.target.value }));

  const q4Avg = SALES_DATA.map(r => ({ region: r.region, avg: r.q4 / 3 })).sort((a, b) => b.avg - a.avg);
  const sorted = [...SALES_DATA].sort((a, b) => b.q4 - a.q4);

  const handleSubmit = () => {
    if (!answers.topRegion.trim() || !answers.difference.trim() || !answers.projected.trim()) return;
    setSubmitted(true);

    const normalize = (s) => s.trim().replace(/\s+/g, '').toLowerCase();
    const normNum = (s) => s.trim().replace(/[₹,\s]/g, '');

    const r1 = normalize(answers.topRegion) === normalize(EXPECTED.topRegion);
    const r2 = normNum(answers.difference) === normNum(EXPECTED.difference);
    const r3 = normNum(answers.projected) === normNum(EXPECTED.projected);

    const details = {
      topRegion: { expected: EXPECTED.topRegion, got: answers.topRegion.trim(), pass: r1 },
      revenueDifference: { expected: EXPECTED.difference, got: answers.difference.trim(), pass: r2 },
      projectedQ1: { expected: EXPECTED.projected, got: answers.projected.trim(), pass: r3 },
    };
    const correct = [r1, r2, r3].filter(Boolean).length;
    onComplete({ score: Math.round((correct / 3) * 100), details, passed: correct === 3 });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-reasoning-hint">
        Study the table carefully. All monetary values are in Indian Rupees (Rs). Type numeric answers with commas e.g. 1,56,60,000
      </div>

      <div className="ab-table-wrap">
      <table className="ab-table">
        <thead>
          <tr>
            <th>Region</th>
            <th>Q1 2025</th>
            <th>Q2 2025</th>
            <th>Q3 2025</th>
            <th>Q4 2025</th>
            <th>Q4 Avg/Month</th>
            <th>Q3→Q4 Growth</th>
          </tr>
        </thead>
        <tbody>
          {SALES_DATA.map(r => {
            const growth = r.q4 - r.q3;
            const isTop = r.region === 'North';
            const isBottom = r.region === 'West';
            return (
              <tr key={r.region} className={isTop ? 'ab-row-top' : isBottom ? 'ab-row-bottom' : ''}>
                <td><strong>{r.region}</strong>{isTop && <span className="ab-region-badge ab-badge-green"> ▲ TOP</span>}{isBottom && <span className="ab-region-badge ab-badge-red"> ▼ LOW</span>}</td>
                <td>{fmt(r.q1)}</td>
                <td>{fmt(r.q2)}</td>
                <td>{fmt(r.q3)}</td>
                <td><strong>{fmt(r.q4)}</strong></td>
                <td>{fmt(Math.round(r.q4 / 3))}</td>
                <td className={growth > 0 ? 'ab-growth-pos' : 'ab-growth-neg'}>+{fmt(growth)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>

      <div className="ab-reasoning-questions">
        <div className="ab-reasoning-q">
          <label className="ab-label">Q1. Which region had the HIGHEST average monthly sales in Q4 2025?</label>
          <input name="topRegion" value={answers.topRegion} onChange={ch}
            className="ab-input ab-answer-input" placeholder="Region name" disabled={submitted} />
        </div>
        <div className="ab-reasoning-q">
          <label className="ab-label">Q2. Total revenue difference between top and bottom region in Q4 2025 (Rs)?</label>
          <input name="difference" value={answers.difference} onChange={ch}
            className="ab-input ab-answer-input" placeholder="e.g. 1,56,60,000" disabled={submitted} />
        </div>
        <div className="ab-reasoning-q">
          <label className="ab-label">Q3. Projected Q1 2026 revenue for North region (if Q3-Q4 linear growth continues)?</label>
          <input name="projected" value={answers.projected} onChange={ch}
            className="ab-input ab-answer-input" placeholder="e.g. 3,90,20,000" disabled={submitted} />
        </div>
      </div>

      {!submitted
        ? <button className="ab-action-btn" onClick={handleSubmit}>Submit All Answers</button>
        : <div className="ab-submitted-badge">✓ Answers Submitted — Evaluating...</div>
      }
    </div>
  );
}
